module.exports = __webpack_public_path__ + "img/msg_carousel_3.c88dbf55.jpg";